export default {"src":"https://cdn.tanzhi.cn/_next/static/media/subscribe-icon.dc550294.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};